import { render, staticRenderFns } from "./OsmStats.vue?vue&type=template&id=220c12c0&scoped=true"
import script from "./OsmStats.vue?vue&type=script&lang=js"
export * from "./OsmStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c12c0",
  null
  
)

export default component.exports